module.exports = __webpack_public_path__ + "img/Logo_SonagiWhite-01.9a01ac54.svg";